import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	saveButton: {
		border: "1px solid",
		boxShadow: "none",
		borderColor: "rgba(126, 13, 214, 0.12)",
		fontWeight: 500,
		...ColorUtil.getBackgroundAndContrastColor("transparent"),
		color: colors.getPrimaryColor(),
		letterSpacing: 0.4,
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor("transparent"),
			boxShadow: "none"
		},
		fontSize: "14px",
		padding: theme.spacing(1, 2)
	},
	button: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[700]),
		height: theme.spacing(2.75),
		borderRadius: theme.spacing(0.5),
		minWidth: 34,
		padding: theme.spacing(1, 1.5),
		fontSize: theme.spacing(1.5),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[700]),
			opacity: 0.8,
			cursor: "pointer"
		}
	},
	buttonText: {
		fontStyle: "normal",
		fontSize: theme.spacing(1.75),
		color: colors.gray[0],
		fontWeight: 500,
		paddingLeft: theme.spacing(0.5),
		height: "100%",
		paddingBottom: theme.spacing(2.75)
	}
}))

export default useStyles
